module.exports = __webpack_public_path__ + "img/syllabus-level1.d529d4d2.png";